import { createBrowserRouter } from "react-router-dom";

import {
  Login,
  Dashboard,
  User,
  PageNotFound,
  Company,
  SkuMapping,
  Retailer,
  UomMapping,
  Synonym,
  Document,
  // UomConversion,
  // Classification,
  Setting,
  Profile,
  DashboardPage,
  Workflow,
  EmailListener,
  TerminalKey,
  UserActivity,
  RetailerGrouping,
  ForgotPassword,
  // Roles,
  CashBalanceReport,
  Roles,
  EmailReadLogs,
  EmailStats,
  EmailInbox,
  EmailInboxPreview,
} from "../pages";
import { Validation } from "@/pages/validation";

export const router = createBrowserRouter([
  {
    element: <Dashboard />,
    children: [
      {
        path: "/users",
        element: <User />,
      },
      {
        path: "/company",
        element: <Company />,
      },
      {
        path: "/sku-mapping",
        element: <SkuMapping />,
      },
      {
        path: "/retailer",
        element: <Retailer />,
      },
      {
        path: "/retailer-grouping",
        element: <RetailerGrouping />,
      },
      {
        path: "/uom-mapping",
        element: <UomMapping />,
      },
      {
        path: "/synonym",
        element: <Synonym />,
      },
      {
        path: "/synonym",
        element: <Synonym />,
      },
      {
        path: "/document",
        element: <Document />,
      },
      {
        path: "/dashboard",
        element: <DashboardPage />,
      },
      {
        path: "/document/details/:doc_id",
        element: <Document.Details />,
      },
      // {
      //   path: "/uom-conversion",
      //   element: <UomConversion />,
      // },
      // {
      //   path: "/classification",
      //   element: <Classification />,
      // },
      // {
      //   path: "/classification/details/:classification_id",
      //   element: <Classification.Details />,
      // },
      {
        path: "/settings",
        element: <Setting />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/workflow",
        element: <Workflow />,
      },
      {
        path: "/email-listener",
        element: <EmailListener />,
      },
      {
        path: "/validation",
        element: <Validation />,
      },
      {
        path: "/terminal-key",
        element: <TerminalKey />,
      },
      {
        path: "/user-activity",
        element: <UserActivity />,
      },
      {
        path: "/email-read-logs",
        element: <EmailReadLogs />,
      },
      {
        path: "/email-read-logs/stats/:log_id",
        element: <EmailStats />,
      },
      {
        path: "/email-inbox",
        element: <EmailInbox />,
      },
      {
        path: "/email-inbox/details/:archive_id",
        element: <EmailInboxPreview />,
      },
      {
        path: "/roles",
        element: <Roles />,
        // element: <Roles />,
        // children: [
        //   {
        //     path: "/reports/cash-balance-report",
        //     element: <CashBalanceReport />,
        //   },
        // ],
      },
      {
        path: "/reports/cash-balance-report",
        element: <CashBalanceReport />,
      },
      {
        path: "*",
        element: <PageNotFound />,
      },
    ],
  },
  { path: "/login", element: <Login /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
]);
